import React from 'react';
import AutocompleteInput from './AutoCompleteInput';
import DateInputField from './DateInputField';
import InputField from './InputField';
import PhoneInputField from './PhoneInputField';
import SelectInputField from './SelectInputField';
import TextAreaInput from './TextAreaInput';
import CurrencyInputField from './CurrencyInputField';
import SingleCheckboxInputField from './CheckboxInputField';
import MultipleSelectInputField from './MultipleSelectInputField';
import TimeInputField from './TimeInputField';
import RadioInputField from './RadioInputField';
import CheckboxGroupField from './CheckboxGroupField';
import SwitchInputField from './SwitchInputField';
import MultipleAutocompleteInput from './MultipleAutoCompleteInput';
import MultipleAutoSelectForCCMProblems from './MultipleAutoSelectForCCMProblems';

const FormField = (inputItem: any): JSX.Element | null => {
  const {type, ...rest} = inputItem;
  switch (type) {
    case 'text':
    case 'email':
    case 'number': {
      return <InputField type={type} {...rest} />;
    }
    case 'date': {
      return <DateInputField {...rest} />;
    }
    case 'time': {
      return <TimeInputField {...rest} />;
    }
    case 'select': {
      if (rest?.multiple) {
        return <MultipleSelectInputField {...rest} />;
      }
      return <SelectInputField {...rest} />;
    }
    case 'phone': {
      return <PhoneInputField {...rest} />;
    }
    case 'textarea': {
      return <TextAreaInput {...rest} />;
    }
    case 'autocomplete': {
      return <AutocompleteInput {...rest} />;
    }
    case 'currency': {
      return <CurrencyInputField {...rest} />;
    }
    case 'single-checkbox': {
      return <SingleCheckboxInputField {...rest} />;
    }
    case 'checkbox': {
      return <CheckboxGroupField {...rest} />;
    }
    case 'radio': {
      return <RadioInputField {...rest} />;
    }
    case 'switch': {
      return <SwitchInputField {...rest} />;
    }
    case 'multiple-autocomplete': {
      return <MultipleAutocompleteInput {...rest} />;
    }
    case 'ccm-problems-multiple-autocomplete': {
      return <MultipleAutoSelectForCCMProblems {...rest} />;
    }
    case 'default': {
      return null;
    }
  }
  return null;
};

export {FormField};
